<template>
  <layout-animated-underline-component
    v-if="isExternalLink"
    :href="data?.url"
    :class="$style.root"
    target="_blank"
    rel="noopener noreferrer"
    component="a"
  >
    <template #default>
      <slot :title="data?.label?.trim()" :current="isCurrentRoute" />
      <span v-if="!slots.default">{{ data?.label?.trim() }}</span>
    </template>
    <template #after>
      ↗
    </template>
  </layout-animated-underline-component>
  <layout-animated-underline-component
    v-else-if="item?.link?.routeObject.name"
    :to="item?.link?.routeObject"
    :class="$style.root"
    :data-current="isCurrentRoute ? '' : null"
    :active="isCurrentRoute"
    :data-logo="title?.trim()?.toLowerCase()?.includes('manifesta') ? '' : null"
  >
    <template #default>
      <template
        v-if="title"
      >
        <slot :title="title" :current="isCurrentRoute" />
        <span
          v-if="!slots.default"
        >
          {{ title }}
        </span>
      </template>
      <template v-else-if="item?.uid">
        <span>
          <slot :title="formatLabel(title)" :current="isCurrentRoute" />
          <span v-if="!slots.default">{{ formatLabel(title ) }}</span>
        </span>
      </template>
    </template>
  </layout-animated-underline-component>
</template>

<script setup>
import { isArray } from 'lodash'

const slots = useSlots()

const mainStore = useMainStore()

const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp
const route = useRoute()

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  truncateLabel: {
    type: Boolean,
    default: false
  }
})

const formatLabel = (label) => {
  if (!label) return
  if (props?.truncateLabel) {
    return baseTruncateString(label, 6)
  } else {
    return label?.trim()
  }
}

const isExternalLink = computed(() => {
  return props?.data?.__component === 'shared.link-external'
})

const item = computed(() => getNavigationItem(props?.data))

const title = computed(() => {
  if ( props?.data?.label?.trim() ) {
    return props?.data?.label?.trim()
  }
  else if (item.value?.title) {
    return item.value?.title
  } else {
    if (item.value?.uid === 'home-page' || item.value?.uid === 'interim-home-page') {
      return getSingleTypeTitle(item.value?.uid)?.replace(/Manifesta/g, 'MANIFESTA')
    } else {
      return getSingleTypeTitle(item.value?.uid)
    }
  }
})

const getRouteBaseName = useRouteBaseName()

const baseRouteName = computed(() => {
  return getRouteBaseName(route)
})

const isCurrentRoute = computed(() => {
  const routesWithChildren = [ 'editions', 'news', 'publications' ]
  const linkRouteName = item.value?.link?.routeObject?.name
  const parentFromisCurrentRoute = baseRouteName.value?.split('-')[0]

  if (routesWithChildren?.some(i => i?.startsWith(parentFromisCurrentRoute))) {
    return linkRouteName?.startsWith(parentFromisCurrentRoute)
  } else {
    if (item.value?.link?.routeObject?.params?.slug) {
      if (item.value?.link?.routeObject?.params?.slug === route?.params?.slug && linkRouteName === baseRouteName.value) {
        return true
      } else {
        return false
      }
    } else {
      return linkRouteName === baseRouteName.value
    }
  }

  return linkRouteName === baseRouteName.value
})
</script>

<style module>
.root {
  composes: reset-link from global;
}

.root[data-logo] {
  font-feature-settings: "dlig" 1;
}
</style>
